(function () {
  'use strict';

  var IMMERSE_OVERFILL = 1.04;
  var ENTRY_DELAY = 0.2;
  var CARD_START_SCALE_DESKTOP = 0.6;
  var CARD_START_SCALE_MOBILE = 0.82;

  // Load every 2nd source frame: frame_count=150 covers images 0001,0003,...,0299
  // Halves HTTP requests while keeping the full visual range.
  var FRAME_STEP = 2;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initHeroScrub(section) {
    if (prefersReducedMotion()) return;

    var canvas      = section.querySelector('[data-hero-canvas]');
    var bgEl        = section.querySelector('[data-hero-bg]');
    var cardEl      = section.querySelector('[data-hero-card]');
    var titleTopEl  = section.querySelector('[data-hero-title-top]');
    var titleBottomEl = section.querySelector('[data-hero-title-bottom]');

    var frameCount       = parseInt(section.dataset.frameCount, 10) || 1;
    var frameUrlTemplate = section.dataset.frameUrl || '';
    var aspect           = parseFloat(section.dataset.aspect) || 1.778;

    var images    = new Array(frameCount);
    var lastDrawn = -1;
    var ctx       = null; // cached once in onFirstReady
    var errored   = 0;

    // RAF throttle state
    var rafId        = null;
    var pendingFrame = -1;

    function frameUrl(i) {
      // Map logical index → every FRAME_STEP-th source image
      var actual = (i * FRAME_STEP) + 1;
      return frameUrlTemplate.replace('{index}', String(actual).padStart(4, '0'));
    }

    function updateCardSize(asp) {
      if (!cardEl) return;
      cardEl.style.width  = 'min(96vw, calc(72svh * ' + asp + '))';
      cardEl.style.height = 'min(72svh, calc(96vw / ' + asp + '))';
    }

    function isLoaded(i) {
      var img = images[i];
      return !!img && img.complete && img.naturalWidth > 0;
    }

    // Draw immediately — called from RAF callback only
    function drawFrameNow(index) {
      if (!canvas || !ctx) return;
      var useIdx = index;

      if (!isLoaded(useIdx)) {
        // Search only nearby frames (max ±10) to avoid visual jumps
        var found = -1;
        var limit = Math.min(10, frameCount);
        for (var d = 1; d <= limit; d++) {
          if (useIdx - d >= 0 && isLoaded(useIdx - d)) { found = useIdx - d; break; }
          if (useIdx + d < frameCount && isLoaded(useIdx + d)) { found = useIdx + d; break; }
        }
        if (found === -1) return; // nothing nearby — keep last drawn, no visual jump
        useIdx = found;
      }

      if (lastDrawn === useIdx) return; // already showing this frame
      ctx.drawImage(images[useIdx], 0, 0, canvas.width, canvas.height);
      lastDrawn = useIdx;
    }

    // Schedule a draw — at most one per animation frame
    function drawFrame(index) {
      pendingFrame = index;
      if (rafId !== null) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        drawFrameNow(pendingFrame);
      });
    }

    function getStartScale() {
      return window.innerWidth < 768 ? CARD_START_SCALE_MOBILE : CARD_START_SCALE_DESKTOP;
    }

    function getImmerseScale() {
      var vw    = window.innerWidth;
      var vh    = window.innerHeight;
      var baseW = Math.min(vw * 0.96, vh * 0.72 * aspect);
      var baseH = Math.min(vh * 0.72, (vw * 0.96) / aspect);
      if (baseW <= 0 || baseH <= 0) return 1.5;
      return Math.max(vw / baseW, vh / baseH) * IMMERSE_OVERFILL;
    }

    function initScrollAnimation() {
      gsap.set(cardEl, { scale: getStartScale(), transformOrigin: '50% 50%' });

      var master = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 0.15, // was 0.4 — tighter response, less perceived lag
          invalidateOnRefresh: true,
          onUpdate: function (self) {
            var p       = self.progress;
            var mapped  = gsap.utils.clamp(0, 1, (p - 0.15) / 0.63);
            var frameIdx = Math.min(frameCount - 1, Math.floor(mapped * frameCount));
            drawFrame(frameIdx);
          },
        },
      });

      master.to(cardEl, { scale: 1, ease: 'power2.out', duration: 0.15 }, 0);
      master.to(titleTopEl, {
        x: function () { return window.innerWidth < 768 ? '-70vw' : '-60vw'; },
        letterSpacing: '0.02em',
        ease: 'power2.inOut',
        duration: 0.15,
      }, 0);
      master.to(titleBottomEl, {
        x: function () { return window.innerWidth < 768 ? '70vw' : '60vw'; },
        letterSpacing: '0.02em',
        ease: 'power2.inOut',
        duration: 0.15,
      }, 0);

      master.to(cardEl, { scale: getImmerseScale(), ease: 'power2.in', duration: 0.63 }, 0.15);
      master.to(titleTopEl,    { opacity: 0, ease: 'power1.in', duration: 0.22 }, 0.15);
      master.to(titleBottomEl, { opacity: 0, ease: 'power1.in', duration: 0.22 }, 0.15);

      master.to(cardEl, { scale: getStartScale(), ease: 'power3.inOut', duration: 0.22 }, 0.78);
      master.to(titleTopEl, {
        x: 0, opacity: 1, letterSpacing: '-0.04em', ease: 'power2.inOut', duration: 0.22,
      }, 0.78);
      master.to(titleBottomEl, {
        x: 0, opacity: 1, letterSpacing: '-0.04em', ease: 'power2.inOut', duration: 0.22,
      }, 0.78);

      ScrollTrigger.refresh();
    }

    // Entry animation (independent of frame loading)
    gsap.timeline({ delay: ENTRY_DELAY })
      .from(bgEl,           { opacity: 0, duration: 1.4, ease: 'power2.out' })
      .from(cardEl,         { opacity: 0, duration: 1.1, ease: 'power3.out' }, 0.35)
      .from(titleTopEl,     { opacity: 0, y:  30, duration: 1, ease: 'expo.out' }, 0.5)
      .from(titleBottomEl,  { opacity: 0, y: -30, duration: 1, ease: 'expo.out' }, 0.62);

    // ── Frame loading ─────────────────────────────────────────
    var cancelled = false;

    function onFirstReady(img) {
      if (cancelled) return;
      if (canvas && img.naturalWidth && img.naturalHeight) {
        canvas.width  = img.naturalWidth;
        canvas.height = img.naturalHeight;
        // Cache context once — avoids repeated getContext() lookups
        ctx = canvas.getContext('2d', { alpha: false, willReadFrequently: false });
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          lastDrawn = 0;
        }
        aspect = img.naturalWidth / img.naturalHeight;
        updateCardSize(aspect);
      }
      initScrollAnimation();
    }

    function loadOne(i) {
      var img = new Image();
      img.decoding = 'async';
      img.onerror  = function () { errored++; };
      if (i === 0) img.onload = function () { onFirstReady(img); };
      img.src   = frameUrl(i);
      images[i] = img;
    }

    // Load 40 frames immediately — better early coverage vs original 20
    var INITIAL = Math.min(40, frameCount);
    for (var i = 0; i < INITIAL; i++) loadOne(i);

    // Remaining frames: batches of 30 every 40ms (was 20 every 80ms — 4× throughput)
    var cursor = INITIAL;
    function loadBatch() {
      if (cancelled) return;
      var end = Math.min(frameCount, cursor + 30);
      for (var j = cursor; j < end; j++) loadOne(j);
      cursor = end;
      if (cursor < frameCount) setTimeout(loadBatch, 40);
    }
    setTimeout(loadBatch, 100);

    return function cleanup() {
      cancelled = true;
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    };
  }

  function setup() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(setup, 50);
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    document.querySelectorAll('[data-section-type="hero-scrub"]').forEach(function (section) {
      initHeroScrub(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
